var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCollapse = function SvgCollapse(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12708_2672)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9567 11.0433H13.9567C13.4044 11.0433 12.9567 10.5956 12.9567 10.0433V1.04327C12.9567 0.490989 13.4044 0.0432739 13.9567 0.0432739C14.509 0.0432739 14.9567 0.490989 14.9567 1.04327V7.62906L20.2929 2.29291C20.6834 1.90239 21.3166 1.90239 21.7071 2.29291C22.0976 2.68344 22.0976 3.3166 21.7071 3.70712L16.3709 9.04327H22.9567C23.509 9.04327 23.9567 9.49099 23.9567 10.0433C23.9567 10.5956 23.509 11.0433 22.9567 11.0433ZM1.04327 12.9568H10.0433C10.5956 12.9568 11.0433 13.4045 11.0433 13.9568V22.9568C11.0433 23.509 10.5956 23.9568 10.0433 23.9568C9.49099 23.9568 9.04327 23.509 9.04327 22.9568V16.371L3.70712 21.7071C3.3166 22.0976 2.68344 22.0976 2.29291 21.7071C1.90239 21.3166 1.90239 20.6834 2.29291 20.2929L7.62906 14.9568H1.04327C0.490989 14.9568 0.0432739 14.509 0.0432739 13.9568C0.0432739 13.4045 0.490989 12.9568 1.04327 12.9568Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12708_2672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCollapse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/collapse.976c56e49372b0ff438387bbaddb1193.svg";